import { render } from "./AddComas.vue?vue&type=template&id=7cebe8f8"
import script from "./AddComas.vue?vue&type=script&lang=js"
export * from "./AddComas.vue?vue&type=script&lang=js"

import "./AddComas.vue?vue&type=style&index=0&id=7cebe8f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__